import { CONFIG } from 'src/config-global';
import FormConstants from '../constants/FormConstants';

type Environment = {
  [key: string]: any;
  encryptDataKey?: string | any;
  API_URL: string;
  dev: boolean;
  production: boolean;
  baseUrl: string;
  baseHost: string;
  encryptLocalStorage: boolean;
  encryptLocalStorageKey: string;
  encryptURLKey: string;
  portalUrl: string;
  msalConfig: any;
  muiLicenseKey: string;
  OAuthConfig: any;
  loginType: string;
  epic: any;
  InActivityTimeOutInMins: any;
  InActivityPromptBeforeIdleInMins: any;
};

const configMsalObject = CONFIG.msalConfig;

export const environment: Environment = {
  API_URL: '/locEnvUrl',
  dev: true,
  production: false,
  baseUrl: 'http://localhost:4500/api/v1',
  baseHost: 'localhost:4500',
  encryptLocalStorage: true,
  encryptLocalStorageKey: 'f74808fb03f94ef8f64350a37918c1b0518c',
  encryptURLKey: 'VAeKOUOjb5iSyuZq1q6NFikq08kkLvrN',
  portalUrl: 'http://localhost:4500',
  msalConfig: configMsalObject ?? {
    auth: [],
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
    system: {},
  },
  muiLicenseKey:
    process.env.REACT_APP_MUI_LICENSE_KEY ??
    '1335d31f525e14ffc80ad022a1bed93bTz0xMDA2MzksRT0xNzYxNDA1ODE1MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
  OAuthConfig: {
    auth: {
      clientId: '1tyFjQnTV2cr3fQOBYBdH3TM3w3DtXcz',
      secretId: 'hjqi6flikxOI6thKMi3eEOWlozumSZMXqKrPd9zRkFWQjasrM5RRkiMHKEVp8Nrs',
      redirectUri: 'https://dev.bytepad.com/bytepad/callback',
      AuthUrl: 'https://dev-z3dmk6e5.us.auth0.com/authorize',
      scope: ['openid profile email'],
    },
  },
  loginType: FormConstants.LOGIN_TYPE.ALL,
  epic: {
    redirectUrl: '',
    clientId: '',
  },
  InActivityTimeOutInMins: 11, // Total timeout = 10 min idle + 1 min response time
  InActivityPromptBeforeIdleInMins: 1, // Prompt shows 1 min before actual logout
};
